export default __webpack_public_path__ + "static/media/template_business-man__0015_12---ChowHingY.828e9609.png";